import { Builder } from '@builder.io/react';
const UnsubscriberWiget = ({
  iframeSms,
  iframeEmail,
  containerClasses = "max-w-5xl mx-auto flex flex-wrap items-start justify-center text-[#00a3da] py-2"
}) => {
  return (
    <div className={containerClasses}>
      <div className={'w-full md:w-[calc(100%_-_100px)] h-[270px]'} dangerouslySetInnerHTML={{ __html: iframeSms }} />
      <div className={'w-full md:w-[calc(100%_-_100px)] h-[270px]'} dangerouslySetInnerHTML={{ __html: iframeEmail }} />
    </div>
  );
};

Builder.registerComponent(UnsubscriberWiget, {
  name: 'UnsubscriberWiget',
  inputs: [
    {
      name: 'iframeSms',
      type: 'text',
      defaultValue: '<iframe src="https://forms.zohopublic.com/zohosam40/form/unsubsms/formperma/WWG6m7NXkVI20pJAJ1mkwQMdzRXN_S_H20ptqhI8f9c" height="100%" width="100%"></iframe>',
      friendlyName: 'SMS Unsubscribe Form',
      helperText: 'Enter the HTML code for the SMS unsubscribe form i-e <iframe src="https://forms.zohopublic.com/zohosam40/form/unsubsms/formperma/WWG6m7NXkVI20pJAJ1mkwQMdzRXN_S_H20ptqhI8f9c" height="100%" width="100%"></iframe>'
    },
    {
      name: 'iframeEmail',
      type: 'text',
      defaultValue: '<iframe src="https://forms.zohopublic.com/zohosam40/form/unsubEmail/formperma/BiOpwj4-obAH_fLZSZ4zFYxKgKTbzImx5Pqfqihsyps" height="100%" width="100%"></iframe>',
      friendlyName: 'Email Unsubscribe Form',
      helperText: 'Enter the HTML code for the Email unsubscribe form i-e <iframe src="https://forms.zohopublic.com/zohosam40/form/unsubEmail/formperma/BiOpwj4-obAH_fLZSZ4zFYxKgKTbzImx5Pqfqihsyps" height="100%" width="100%"></iframe>'
    },
    {
      name: 'containerClasses',
      type: 'string',
      defaultValue: 'max-w-5xl mx-auto flex flex-wrap items-start justify-center text-[#00a3da] py-2',
      friendlyName: 'Container Classes',
      helperText: 'Custom Tailwind CSS classes for the main container'
    },
  ],
});

export default UnsubscriberWiget;